import {
  ComponentWithAs,
  Container,
  forwardRef,
  Heading,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React from 'react';

type CreditModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const CreditModal: ComponentWithAs<'section', CreditModalProps> = forwardRef<CreditModalProps, 'section'>(
  (props, ref) => {
    return (
      <Modal size='md' {...props}>
        <ModalOverlay />
        <ModalContent ref={ref}>
          <ModalBody>
            <Container centerContent py={6}>
              <Heading size='sm'>숨쉴때 뭐먹지를 만든 사람들</Heading>
              <Text>
                <br />
              </Text>
              <Heading size='sm'>Supervisor</Heading>
              <Link href='https://github.com/Margarets00'>Margarets</Link>
              <Text>
                <br />
              </Text>
              <Heading size='sm'>Web Development</Heading>
              <Link href='https://github.com/EATSTEAK'>EATSTEAK</Link>
              <Link href='https://github.com/minai621'>MJ</Link>
              <Text>
                <br />
              </Text>
              <Heading size='sm'>Design</Heading>
              <Text>Erin</Text>
              <Text>
                <br />
              </Text>
              <Heading size='sm'>Project Manager</Heading>
              <Link href='https://github.com/Bucky5683'>Bucky</Link>
              <Text>
                <br />
              </Text>
              <Heading size='sm'>Yourssu</Heading>
              <Link href='https://intro.yourssu.com/'>About us</Link>
              <Link href='https://www.notion.so/YOURSSU-Blog-8e064a720d1942d68aa42093b7d2f5b6'>
                Tech blog
              </Link>
              <Link href='https://www.notion.so/YOURSSU-Recruit-7d4ebe53ad554ea0877e0980b47623ae'>
                Recruit
              </Link>
            </Container>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  },
);

export default CreditModal;
